<template>
  <div class="d-flex justify-content-center align-items-center paypro">
    <div class="text-center">
      <div class="spinner loading"></div>
      <div class="error-text">Processing Payment...</div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
export default {
  name: "paymentCheck",

  components: {
    Slick
  },
  data() {
    return {
      ref: "",
      rid: ""
    };
  },
  mounted() {
    this.ref = this.$route.query.ref;
    this.rid = this.$route.query.rid;
    setTimeout(() => this.getBookingDetails(), 3000);
  },
  methods: {
    getBookingDetails: function() {
      console.log(this.ref);
      let payload = {
        Ref: this.ref,
        rid: this.rid
      };

      makeRequest("/BookStatusNew", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          //console.log(response);
          if (!error && res.data.Status) {
            window.location.href = "/confirmBooking/" + res.data.ReserveID;
            // this.$router.push({
            //   path: "/confirmBooking/"+res.data.ReserveID,
            //   // params: { bookingId: res.data.ReserveID }
            // });
          } else {
            window.location.pathname = "/failedPayment";
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          //   window.location.pathname = "/failedPayment";
          //   console.log("Error on vue front", error);
        });
    }
  }
};
</script>

<style>
/* .modal-bg {
  width: 100%;
  position: fixed;
  z-index: 100000;
  margin: 0 0 auto auto;
  background: #00000078;
  padding: 100px 0 0 0;
  height: 100%;
} */

.navbar {
  display: none;
}

footer {
  display: none;
}

.paypro {
  height: (100vh - 183px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/paymentCheck.vue